import {Component, Injectable, NgModule} from '@angular/core';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import {Observable} from 'rxjs';

 //@Injectable()
@NgModule()
export class instiRoutehandle{
  constructor(protected activated_route: ActivatedRoute, 
              protected route: Router,
              ) {
      
      /*
    const id: Observable<string> = route.params.pipe(map(p => p.id));
    const url: Observable<string> = route.url.pipe(map(segments => segments.join('')));
    const user = route.data.pipe(map(d => d.user));
    */
  }
  public getRoutObj(){ return this.route;}
  public getActivatedRoute(){ return this.activated_route;}
  /**
   * Aluisio Ferreira de sousa 11/09/2019
   * Retorna o queryParams.value de uma rota
   * ou o valor de uma propriedade do queryparams
   * @return NULL, {OBJECT}
   *  
   */
  public getParams(property?:string){
    let a:any=this.getActivatedRoute();
    let b:any=a.queryParams;   
    let v=b.getValue();
    
    if(!property){ return v;}
    if(!v.hasOwnProperty(property)){
       
        return null;
    }
    return v[property];
  }
  /**
   * Aluisio Ferreira de sousa 11/09/2019
   * verifica se existem valores no queryParams 
   * ou checa se uma determinada propriedade existe no queryParams 
   */
  public getHasParams(property?:string){
      var p=this.getParams();
      if(!p){ return false;}
      var k=Object(p).keys;
      
      if(!k.length){ return false; }
      if(!property){ return true;}
      return k.indexOf(property)< 0 ? false :true;
  } 
}



/*
@NgModule({
  providers: [
   {
    provide: instiRouteProperty,
    useClass: instiRouteProperty,
    multi: true,
   },
  ],
  })

  
  export class instiRoutehandle{}
  */